import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetEditor';
import { EquipmentStatus, IEquipmentStatusProps } from '../../../Equipment/EquipmentStatus';

interface IWorksheetEquipmentStatusProps extends IEquipmentStatusProps {
  createWorksheetSelector?: any;
  focusRef?: React.Ref<HTMLButtonElement>;
  value?: any;
}

// Component mapping worksheet editor state to a standard EquipmentStatus component
// Only used when the calibration status icon is shown independently of a WorksheetEquipmentLabel
// e.g. for grid entry
let WorksheetEquipmentStatus: React.FC<IWorksheetEquipmentStatusProps> = ({
  focusRef,
  createWorksheetSelector,
  value,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const worksheetId = useSelector((s) => s.worksheetEditor.worksheetId);
  const importAction = useCallback((importModel: any) => dispatch(actions.import({ worksheetId, importModel })), [
    dispatch,
    worksheetId,
  ]);
  const statusDate = useSelector(createWorksheetSelector('header.TestedDate', false));
  const importing = useSelector((s) => s.worksheetEditor.status.importing);
  const props = {
    ...otherProps,
    equipment: value,
    focusRef,
    importAction,
    status: value?.Status,
    statusDate,
    worksheetId,
    importing,
  };
  return <EquipmentStatus {...props} />;
};

WorksheetEquipmentStatus = withInjectedProps(WorksheetEquipmentStatus);

export { WorksheetEquipmentStatus };
